// 发送目标与成员的草稿换算（决策 D66、D69）：目标是通道组或单个通道，草稿里记成 g1、c5 这样的键。
// 路由规则的发送目标与通道组的成员共用（D131）。
import type { Channel, ChannelGroup } from "@/app/master";

/** 失败重试策略参数的取值范围，与服务端的快照校验一致（决策 D62、D69）。 */
export const RETRY_TIMEOUT_MIN = 5;
export const RETRY_TIMEOUT_MAX = 86400;
export const RETRY_ATTEMPTS_MAX = 5;

/** 通道组或通道的 id 换成目标键；两个都没有时是空串。 */
export function targetKey(groupID: number | null, channelID: number | null): string {
  return channelID ? `c${channelID}` : groupID ? `g${groupID}` : "";
}

/** 目标键是不是单个通道（决策 D66）。 */
export function isChannelTarget(key: string): boolean {
  return key.startsWith("c");
}

/** 目标键换回二选一的两个字段。 */
export function parseTarget(key: string): { group: number | null; channel: number | null } {
  const id = Number(key.slice(1)) || null;
  return isChannelTarget(key) ? { group: null, channel: id } : { group: id, channel: null };
}

/** 目标下拉的选项：通道组在前、通道在后。 */
export function targetOptions(groups?: ChannelGroup[], channels?: Channel[]) {
  return [
    ...(groups ?? []).map((g) => ({ value: targetKey(g.id, null), label: g.name, hint: "通道组合" })),
    ...(channels ?? []).map((c) => ({ value: targetKey(null, c.id), label: c.name, hint: "通道" })),
  ];
}

/** 把 id 换成名字，列表摘要用。 */
export interface TargetNames { group: (id: number) => string; channel: (id: number) => string }

/** 目标的展示名：通道组名，或"通道 名字"。 */
export function targetName(group: number | null, channel: number | null, names: TargetNames): string {
  return channel ? `通道 ${names.channel(channel)}` : group ? names.group(group) : "未选目标";
}
